var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-to-top",class:_vm.visible ? 'show-scrollTop' : ''},[_c('button',{staticClass:"goTop",attrs:{"type":"button"},on:{"click":_vm.scrollTop}},[_c('i',{staticClass:"fa fa-chevron-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }